import {
  conversationBelongsToCustomer,
  resolveTemplateChatId
} from './resolveOutboundRecipient';

export const MS_TEMPLATE_PLATFORMS = [
  'whatsapp_bsp_messages',
  'whatsapp_gupshup_messages'
];

export const MS_QR_PLATFORM = 'whatsapp_qr_messages';

export const MS_WHATSAPP_PLATFORMS = [
  'whatsapp_bsp_messages',
  'whatsapp_qr_messages',
  'whatsapp_gupshup_messages'
];

const MS_WHATSAPP_PLATFORM_ENUM = {
  0: 'whatsapp_bsp_messages',
  1: 'whatsapp_qr_messages',
  8: 'whatsapp_gupshup_messages'
};

export function normalizeMsWhatsappPlatform(platform) {
  if (platform === undefined || platform === null || platform === '') return platform;
  if (typeof platform === 'number' || (typeof platform === 'string' && /^\d+$/.test(platform))) {
    return MS_WHATSAPP_PLATFORM_ENUM[Number(platform)] || platform;
  }
  return platform;
}

export function isMsTemplatePlatform(platform) {
  return MS_TEMPLATE_PLATFORMS.includes(platform);
}

export function isMsQrPlatform(platform) {
  return normalizeMsWhatsappPlatform(platform) === MS_QR_PLATFORM;
}

export function isMsWhatsappPlatform(platform) {
  return MS_WHATSAPP_PLATFORMS.includes(normalizeMsWhatsappPlatform(platform));
}

export function integrationLabel(integration) {
  return integration?.name || integration?.phone_number || integration?.platform || '';
}

export function filterActiveTemplateIntegrations(integrations) {
  return (integrations || []).filter(
    (integration) => integration.status === 'active'
      && isMsTemplatePlatform(integration.platform)
  );
}

export function filterActiveWhatsappIntegrations(integrations) {
  return (integrations || []).reduce((acc, integration) => {
    if (integration.status !== 'active') return acc;
    const platform = normalizeMsWhatsappPlatform(integration.platform);
    if (!MS_WHATSAPP_PLATFORMS.includes(platform)) return acc;
    acc.push({ ...integration, platform });
    return acc;
  }, []);
}

export function boundConversationIntegration(conversation, customerId) {
  const platform = normalizeMsWhatsappPlatform(conversation?.platform);
  if (!conversation?.platformRetailerId || !isMsWhatsappPlatform(platform)) {
    return null;
  }
  if (!conversationBelongsToCustomer(conversation, customerId)) return null;

  return {
    id: conversation.platformRetailerId,
    platform,
    name: conversation.platformRetailerName || null,
    status: 'active'
  };
}

function chatAttributes(chat) {
  return chat?.attributes || chat || {};
}

export function chatPlatformRetailerId(chat) {
  const attrs = chatAttributes(chat);
  return attrs.platform_retailer_id || chat?.platformRetailerId || null;
}

export function chatIdFromRecord(chat) {
  return chat?.id || chatAttributes(chat).id || undefined;
}

export function autoSelectIntegrationId(integrations, customerChats) {
  if (!integrations?.length) return null;

  const chatIntegrationIds = new Set(
    (customerChats || []).map(chatPlatformRetailerId).filter(Boolean).map(String)
  );
  const matching = integrations.filter((integration) => (
    chatIntegrationIds.has(String(integration.id))
  ));

  if (matching.length === 1) return matching[0].id;
  if (integrations.length === 1) return integrations[0].id;
  if (matching.length > 1) return matching[0].id;
  return null;
}

export function chatIdForMsSend({
  conversation,
  customerId,
  customerChats,
  integrationId
}) {
  if (!integrationId) return undefined;

  const conversationChatId = resolveTemplateChatId(conversation, customerId);
  if (
    conversationChatId
    && String(conversation.platformRetailerId) === String(integrationId)
  ) {
    return conversationChatId;
  }

  const chat = (customerChats || []).find((item) => (
    String(chatPlatformRetailerId(item)) === String(integrationId)
  ));
  const chatId = chatIdFromRecord(chat);
  return chatId ? String(chatId) : undefined;
}

export function customerPhoneNumber(customer) {
  return customer?.phone_with_country_code || customer?.phone || undefined;
}
